import {
  styled,
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from "@mui/material";

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)(() => ({
  // ... existing styles
}));

interface ButtonProps extends MuiToggleButtonGroupProps {
  children: React.ReactNode;
}

export const ToggleButtonGroup: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledToggleButtonGroup {...props}>{children}</StyledToggleButtonGroup>;
};

export default ToggleButtonGroup;
